import { render } from "./PrimaryBtn.vue?vue&type=template&id=21dc3100&scoped=true"
import script from "./PrimaryBtn.vue?vue&type=script&lang=js"
export * from "./PrimaryBtn.vue?vue&type=script&lang=js"

import "./PrimaryBtn.vue?vue&type=style&index=0&id=21dc3100&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-21dc3100"

export default script